import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";

export function removeAnimal(body, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({FarmID, ClientID, LocalUserID});
    return invokeApig({
        ...Paths.removeAnimal({farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID}),
        body
    })
}

export function removeAnimalNotificationSuccess(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("logView.tableName.animals"),
        message: i18n.t("apiNotifications.removeAnimalSuccess"),
        status: 'success',
        dismissible: true,
        dismissAfter: 5000
    }))
}

export function removeAnimalNotificationFailure(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("logView.tableName.animals"),
        message: i18n.t("apiNotifications.removeAnimalFailure"),
        status: 'error',
        dismissible: true,
        // buttons: checkLogsButton(),
        dismissAfter: 15000
    }))
}
